import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles<ITheme>((theme) => ({
  emptyBox: () => ({
    position: 'absolute',
    width: 60,
    height: 60,
    backgroundColor: 'white',
    top: 80,
    left: 30,
    [theme.breakpoints.down('xs')]: {
      top: 10,
      left: 15,
    },
  }),
  loadingContainer: {
    top: 0,
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    zIndex: 1001,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingInfo: {
    paddingTop: 16,
    fontWeight: 700,
    width: 220,
    color: colors.darkestGray,
    textAlign: 'center',
  },
  circle: {
    strokeLinecap: 'round',
  },
  circleBackground: {
    strokeLinecap: 'round',
    color: colors.darkGray,
  },
  progress: {
    left: 0,
    position: 'absolute',
  },
}));
